__turbopack_context__.v({
  "contents": "-B5vjG_contents",
  "hasScroll": "-B5vjG_hasScroll",
  "hasScrolled": "-B5vjG_hasScrolled",
  "lastRow": "-B5vjG_lastRow",
  "outerContents": "-B5vjG_outerContents",
  "scrollRightButton": "-B5vjG_scrollRightButton",
  "secondLastRow": "-B5vjG_secondLastRow",
});
